import React from "react";

const ConditionsUtilisation = () => {
    return (
        <div className="container top">
            <h2 >Conditions d’Utilisation – Pressing360</h2>
            <section className="mt-5 mb-5">
                <h3>1. Présentation du service</h3>
                <p>
                    <strong>Pressing360</strong> est une application professionnelle de
                    gestion dédiée aux pressings et laveries.
                </p>
                <ul>
                    <li>Enregistrement rapide des dépôts</li>
                    <li>Gestion des clients et des vêtements</li>
                    <li>Génération automatique d’ID</li>
                    <li>Suivi des ventes en temps réel</li>
                    <li>Impression de tickets thermiques</li>
                    <li>Notifications WhatsApp / Email (selon configuration)</li>
                </ul>
                <p>
                    L’application est accessible en ligne via ordinateur, tablette ou
                    smartphone connecté à Internet.
                </p>
            </section>

            <section className="mt-5">
                <h3>2. Impression des tickets – Matériel requis</h3>
                <p>
                    Pour une utilisation optimale, le client doit disposer :
                </p>
                <ul>
                    <li> D’une imprimante thermique 80mm recommandée</li>
                </ul>
                <p>
                    Le ticket imprimé constitue la preuve principale de dépôt.
                    Les notifications WhatsApp viennent en complément.
                </p>
            </section>

            <section className="mt-5">
                <h3>3. Notifications WhatsApp – Service complémentaire</h3>
                <p>
                    L’envoi de notifications via WhatsApp est une fonctionnalité
                    complémentaire.
                </p>
                <p style={styles.warning}>
                    WhatsApp peut se déconnecter temporairement en raison de
                    limitations officielles imposées par WhatsApp, mises à jour de
                    sécurité ou connexion instable.
                </p>
                <p>
                    En cas de déconnexion :
                </p>
                <ul>
                    <li>Le client doit contacter le service technique</li>
                    <li> le client doit disposer d’un ordinateur (même personnel)</li>
                    <li>Une reconnexion sera effectuée</li>
                    <li>La manipulation dure 5 à 10 minutes maximum</li>
                </ul>
            </section>

            <section className="mt-5">
                <h3>4. Lenteur ou dysfonctionnement</h3>
                <p>
                    En cas de lenteur ou problème d’accès, le client doit signaler
                    immédiatement le problème.
                </p>
                <p>
                    Pressing360 ne peut être tenu responsable des lenteurs liées à :
                </p>
                <ul>
                    <li>Connexion Internet instable</li>
                    <li>Matériel obsolète</li>
                    <li>Problème réseau local</li>
                </ul>
            </section>

            <section className="mt-5">
                <h3>5. Gestion des offres</h3>
                <p>
                    Lors de la création du compte, toutes les offres fournies seront
                    intégrées dans l’application.
                </p>
                <p>
                    Le client peut modifier, ajouter ou supprimer des services en suivant
                    la formation disponible :
                </p>
                <a
                    href="https://formation.pressing360.com/"
                    target="_blank"
                    rel="noopener noreferrer"

                >
                    https://formation.pressing360.com/
                </a>
                <p>
                    Si l’équipe Pressing360 doit effectuer ces modifications :
                    <strong> 5.000 FCFA par intervention.</strong>
                </p>
            </section>

            <section className="mt-5">
                <h3>6. Processus 100% en ligne</h3>
                <p>
                    Tous les services (paiement, création, formation, support) se font en ligne.
                </p>
                <h4>Déplacement physique (optionnel)</h4>
                <ul>
                    <li>Abidjan : 10.000 FCFA</li>
                    <li>Intérieur Côte d’Ivoire : à partir de 10.000 FCFA</li>
                    <li>Autres pays : tarif selon localisation</li>
                </ul>
            </section>

            <section className="mt-5">
                <h3>7. Responsabilité du client</h3>
                <ul>
                    <li>Fournir des informations exactes</li>
                    <li>Sécuriser ses identifiants</li>
                    <li>Disposer d’un matériel adapté</li>
                    <li>Signaler tout problème technique</li>
                </ul>
            </section>

            <section className="mt-5">
                <h3>8. Suspension du service</h3>
                <p>
                    Pressing360 se réserve le droit de suspendre un compte en cas de :
                </p>
                <ul>
                    <li>Non-paiement</li>
                    <li>Utilisation frauduleuse</li>
                    <li>Non-respect des présentes conditions</li>
                </ul>
            </section>

            <section className="mt-5">
                <h3 >9. Acceptation</h3>
                <p>
                    L’utilisation de Pressing360 implique l’acceptation complète des
                    présentes conditions.
                </p>
            </section>

            <footer className="mt-5">
                © {new Date().getFullYear()} Pressing360 – Tous droits réservés.
            </footer>
        </div>
    );
};

const styles = {
    warning: {
        backgroundColor: "#fff3cd",
        padding: "10px",
        borderLeft: "4px solid #ffc107",
        margin: "10px",
    }
};

export default ConditionsUtilisation;
